<template>
    <q-card class="datos-obra-card">
        <q-card-section class="card-header">
            <div class="row items-center no-wrap">
                <q-icon name="engineering" size="32px" class="q-mr-md header-icon" />
                <div class="col">
                    <div class="text-h5 text-weight-bold">Datos de la Obra</div>
                    <div class="text-caption text-grey-3">Información del proyecto</div>
                </div>
            </div>
        </q-card-section>

        <q-separator />

        <q-card-section class="card-content">
            <div class="row q-col-gutter-md q-mb-md">
                <div class="col-12 col-md-4">
                    <div class="input-label">
                        <q-icon name="tag" size="18px" class="q-mr-xs" />
                        Referencia
                    </div>
                    <q-input
                        outlined
                        dense
                        :model-value="presup?.obra.referencia"
                        readonly
                        class="modern-input"
                    >
                        <template v-slot:prepend>
                            <q-icon name="label" color="primary" />
                        </template>
                    </q-input>
                </div>
                <div class="col-12 col-md-4">
                    <div class="input-label">
                        <q-icon name="business" size="18px" class="q-mr-xs" />
                        Cliente
                    </div>
                    <q-input
                        outlined
                        dense
                        :model-value="presup?.obra.cliente?.A1_NOME"
                        readonly
                        class="modern-input"
                    >
                        <template v-slot:prepend>
                            <q-icon name="person" color="primary" />
                        </template>
                    </q-input>
                </div>
                <div class="col-12 col-md-4">
                    <div class="input-label">
                        <q-icon name="business" size="18px" class="q-mr-xs" />
                        CUIT
                    </div>
                    <q-input
                        outlined
                        dense
                        :model-value="presup?.obra.cliente?.A1_CGC"
                        readonly
                        class="modern-input"
                    >
                        <template v-slot:prepend>
                            <q-icon name="person" color="primary" />
                        </template>
                    </q-input>
                </div>
            </div>

            <div class="row q-col-gutter-md q-mb-md">
                <div class="col-12">
                    <div class="input-label">
                        <q-icon name="place" size="18px" class="q-mr-xs" />
                        Dirección
                    </div>
                    <q-input
                        outlined
                        dense
                        :model-value="presup?.obra.direccion"
                        readonly
                        class="modern-input"
                    >
                        <template v-slot:prepend>
                            <q-icon name="location_on" color="primary" />
                        </template>
                    </q-input>
                </div>
            </div>

            <div class="row q-col-gutter-md q-mb-md">
                <div class="col-12">
                    <div class="input-label">
                        <q-icon name="notes" size="18px" class="q-mr-xs" />
                        Observaciones
                    </div>
                    <q-input
                        outlined
                        dense
                        :model-value="presup?.obra.observaciones"
                        type="textarea"
                        rows="3"
                        readonly
                        class="modern-input"
                    >
                        <template v-slot:prepend>
                            <q-icon name="comment" color="primary" />
                        </template>
                    </q-input>
                </div>
            </div>

            <div class="section-divider q-mb-md">
                <q-icon name="contact_phone" size="18px" class="q-mr-xs" />
                Contacto Comercial
            </div>

            <div class="row q-col-gutter-md q-mb-md">
                <div class="col-12 col-md-4">
                    <div class="input-label">
                        <q-icon name="person" size="18px" class="q-mr-xs" />
                        Nombre
                    </div>
                    <q-input
                        outlined
                        dense
                        :model-value="presup?.obra.contacto_comercial_nombre"
                        readonly
                        class="modern-input"
                    >
                        <template v-slot:prepend>
                            <q-icon name="badge" color="primary" />
                        </template>
                    </q-input>
                </div>
                <div class="col-12 col-md-4">
                    <div class="input-label">
                        <q-icon name="phone" size="18px" class="q-mr-xs" />
                        Teléfono
                    </div>
                    <q-input
                        outlined
                        dense
                        :model-value="presup?.obra.contacto_comercial_tel"
                        readonly
                        class="modern-input"
                    >
                        <template v-slot:prepend>
                            <q-icon name="phone" color="primary" />
                        </template>
                    </q-input>
                </div>
                <div class="col-12 col-md-4">
                    <div class="input-label">
                        <q-icon name="email" size="18px" class="q-mr-xs" />
                        Email
                    </div>
                    <q-input
                        outlined
                        dense
                        :model-value="presup?.obra.contacto_comercial_email"
                        readonly
                        class="modern-input"
                    >
                        <template v-slot:prepend>
                            <q-icon name="alternate_email" color="primary" />
                        </template>
                    </q-input>
                </div>
            </div>

            <div class="section-divider q-mb-md">
                <q-icon name="local_shipping" size="18px" class="q-mr-xs" />
                Contacto Logístico
            </div>

            <div class="row q-col-gutter-md">
                <div class="col-12 col-md-4">
                    <div class="input-label">
                        <q-icon name="person" size="18px" class="q-mr-xs" />
                        Nombre
                    </div>
                    <q-input
                        outlined
                        dense
                        :model-value="presup?.obra.contacto_logistico_nombre"
                        readonly
                        class="modern-input"
                    >
                        <template v-slot:prepend>
                            <q-icon name="badge" color="primary" />
                        </template>
                    </q-input>
                </div>
                <div class="col-12 col-md-4">
                    <div class="input-label">
                        <q-icon name="phone" size="18px" class="q-mr-xs" />
                        Teléfono
                    </div>
                    <q-input
                        outlined
                        dense
                        :model-value="presup?.obra.contacto_logistico_tel"
                        readonly
                        class="modern-input"
                    >
                        <template v-slot:prepend>
                            <q-icon name="phone" color="primary" />
                        </template>
                    </q-input>
                </div>
                <div class="col-12 col-md-4">
                    <div class="input-label">
                        <q-icon name="email" size="18px" class="q-mr-xs" />
                        Email
                    </div>
                    <q-input
                        outlined
                        dense
                        :model-value="presup?.obra.contacto_logistico_email"
                        readonly
                        class="modern-input"
                    >
                        <template v-slot:prepend>
                            <q-icon name="alternate_email" color="primary" />
                        </template>
                    </q-input>
                </div>
            </div>
        </q-card-section>

        <q-separator />

        <q-card-actions align="right" class="q-pa-md">
            <q-btn
                unelevated
                color="primary"
                icon="edit"
                label="Editar"
                @click="obraCrudOpen = true"
                :disable="!checkPermission('obra.editar')"
                no-caps
            >
                <q-tooltip v-if="!checkPermission('obra.editar')">
                    No tienes permisos para editar
                </q-tooltip>
            </q-btn>
        </q-card-actions>

        <ObraCrud v-model="obraCrudOpen" :id="presup?.obra.id" oper="edit" @updated="emit('obra-updated')" />
    </q-card>
</template>

<script setup>
import ObraCrud from "@/components/obra/ObraCrud.vue";
import { ref } from "vue";
import { useAuthStore } from "@/stores/useAuthStore.js";

const { checkPermission } = useAuthStore();
const emit = defineEmits(["obra-updated"]);
const { presup, tieneConfirmados } = defineProps({
    presup: Object,
    tieneConfirmados: Boolean
});
const obraCrudOpen = ref(false);

</script>

<style lang="scss" scoped>
.datos-obra-card {
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    transition: all 0.3s ease;

    &:hover {
        box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
    }
}

.card-header {
    background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);
    color: white;
    padding: 24px;

    .header-icon {
        opacity: 0.95;
    }
}

.card-content {
    padding: 24px;
    background: linear-gradient(to bottom, #fafafa 0%, #ffffff 100%);
}

.input-label {
    font-size: 13px;
    font-weight: 600;
    color: #424242;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.modern-input {
    :deep(.q-field__control) {
        background: white;
        border-radius: 8px;
        transition: all 0.2s ease;

        &:hover {
            box-shadow: 0 2px 8px rgba(25, 118, 210, 0.1);
        }
    }

    :deep(.q-field__native) {
        color: #424242;
        font-weight: 500;
    }

    :deep(textarea.q-field__native) {
        resize: none;
    }
}

.section-divider {
    font-size: 13px;
    font-weight: 700;
    color: #1976d2;
    display: flex;
    align-items: center;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    border-bottom: 2px solid rgba(25, 118, 210, 0.15);
    padding-bottom: 8px;
}

.action-btn {
    font-weight: 500;
    padding: 8px 24px;
    border-radius: 8px;
    transition: all 0.2s ease;

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(25, 118, 210, 0.3);
    }
}

// Responsive
@media (max-width: 768px) {
    .card-header {
        padding: 16px;

        .text-h5 {
            font-size: 18px;
        }
    }

    .card-content {
        padding: 16px;
    }

    .input-label {
        font-size: 12px;
    }
}
</style>
